export default "__VITE_ASSET__Dn1gJB60__"